import styled from "@emotion/styled";
import { mq } from "@styles/helpers";
import { Devices } from "@styles/tokens";

export const ModalContent = styled.div`
    min-width: 40vw;
    max-width: 80vw;
    padding:1.2rem 2rem 1.7rem 2rem;
    background:#fff;
    border-radius: 10px;
    box-shadow: 0 0 3px rgba(0,0,0,0.25);
    margin-top: 2rem;
    max-height: 70vh;
    height:100vh;
`;

export const ModalContent2 = styled.div`
    min-width: 20vw;
    max-width: 80vw;
    padding:1.2rem 2rem 1.7rem 2rem;
    background:#fff;
    border-radius: 10px;
    box-shadow: 0 0 3px rgba(0,0,0,0.25);
    margin-top: 2rem;
    max-height: 70vh;
    min-height:10vh;
`;

export const TitleLeft = styled.div`
    font-size: 20px;
    font-weight: 600;
    display:flex;
    align-items: center;
    color:#414141;

    button{
        margin-left: auto;
        font-size: 14px;
        font-weight: 400;
        background:#2A848E;
        color:#fff;
        padding:0.4rem 1rem;
        border-radius: 20px;

        &:hover{
            opacity: 0.8;
        }
    }
`;

export const DataListWrap = styled.div`
    height:calc(100% - 78px );
    overflow:auto;  
    scrollbar-width: thin;

    ::-webkit-scrollbar {
        width: 10px;
    }

    ::-webkit-scrollbar-track {
        background-color: darkgrey;
    }
    ::-webkit-scrollbar-thumb {
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    }
`;

export const DashList = styled.table`
    width:100%;
    margin-top: 1rem;
    border-collapse: collapse;

    td{
        font-size: 14px;
        padding:5px 10px;

        &:last-of-type{
            text-align: right;
        }
    }

    tr:not(:nth-of-type(1)){
        td{

            height: 34px;
        }
    }

    tr:nth-of-type(1){
        font-weight: 600;
    }

    span{
        display:block;
        white-space: nowrap;
    }
`;

export const Td = styled.td<{}>`
    font-size: 16px !important;
    transition: all 0.1s ease-in-out;
    white-space: nowrap;
    color:#414141;

    svg{
        height:14px;
        path{
            fill:#888888;
        }
    }
`;

export const TrMain = styled.tr<{}>`
    background:#ECECEC;
    font-weight: 500;
`;

export const TrSub = styled.tr<{last?:boolean}>`

    td:not(:last-of-type(1)){
        border-bottom: 1px solid ${props => props.last?"transparent":"#C6C6C6"};
    }

    svg{
        height:16px;
        margin-right: 8px;
        path{
            fill:#acacac;
        }
    }
`;

export const ButtonRow = styled.div`
    width:100%;
    display:flex;
    justify-content: end;
    margin-top: 20px;
    
    button{
        border: 1px solid #ACACAC;
        height:30px;
        min-width: 130px;
        border-radius: 5px;
        font-size: 16px;
        font-weight: 400;

        &:hover{
            border: 1px solid #2A848E;
            background:#2A848E;
            color:#fff;
        }
    }
`;

export const ActionBar = styled.div`
    display:flex;
    gap:1rem;
    margin-left: auto;
    justify-content: end;

    svg{
        cursor: pointer;
        width:18px;

        path{
            fill:#888888;
        }

        :hover{
            opacity: 0.8;
        }
    }
`;